import * as React from "react";

import { formatDistance, subHours } from "date-fns";

import { getRecentSignatures } from "../../common/routes";
import { RecentSignatureListed } from "../../common/types";

import { memberTheme } from "@flow/frontend/member/memberTheme";
import { useInterval } from "@flow/lib/use_interval";
import { Person } from "@mui/icons-material";
import { Avatar, Stack, Typography } from "@mui/material";

export function RecentSignatures(props: { petitionGuid: string; petitionRecentSignatureLabel: string }) {
  const [recentSignatures, setRecentSignatures] = React.useState<RecentSignatureListed[]>([]);
  const [activeSignature, setActiveSignature] = React.useState<RecentSignatureListed | undefined>(undefined);
  const [idx, setIdx] = React.useState<number>(0);

  const oneHourAgo = subHours(new Date(), 1);

  React.useEffect(() => {
    setRecentSignatures([]);
    getRecentSignatures.call({ petitionGuid: props.petitionGuid }).then((signatures) => {
      setIdx((idx + 1) % signatures.length);
      setRecentSignatures(signatures);
      setActiveSignature(signatures[idx]);
    });
  }, [props.petitionGuid]);

  useInterval(() => {
    // Turn this off if working on styling, the cycling makes it very difficult to inspect element
    setIdx((idx + 1) % recentSignatures.length);
    setActiveSignature(recentSignatures[idx]);
  }, 2000);

  const signedText = (signed_at: Date) => {
    return `${props.petitionRecentSignatureLabel}${
      signed_at <= oneHourAgo ? "" : ` ${formatDistance(signed_at, new Date())} ago`
    }`;
  };

  const renderSignature = () => {
    return (
      activeSignature && (
        <Stack direction="row" height={{ xs: "3rem", md: "4rem" }} spacing={1}>
          <Avatar sx={{ height: "1.5rem", width: "1.5rem", backgroundColor: memberTheme.palette.primary.grey }}>
            <Person sx={{ color: "white", height: "75%" }} />
          </Avatar>
          <Typography variant="body2" lineHeight="1.5rem">
            <strong>{activeSignature.name}</strong> {signedText(activeSignature.signed_at)}
          </Typography>
        </Stack>
      )
    );
  };

  return <div>{renderSignature()}</div>;
}
